"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const Card = createJourneyComponent_1.createJourneyComponent('j-card', 'div');
exports.default = Card;
